import { BraidProvider} from 'braid-design-system';
import seekBusiness from 'braid-design-system/themes/seekBusiness';
import seekJobs from 'braid-design-system/themes/seekJobs';
import { type ReactNode } from 'react';

const THEMES = { seekBusiness, seekJobs } as const;

type BraidThemeName = keyof typeof THEMES;

interface ProviderProps {
  braidThemeName: BraidThemeName;
  children: ReactNode;
}

export const BraidDesignProvider = ({
  braidThemeName,
  children,
}: ProviderProps) => (
  <BraidProvider theme={THEMES[braidThemeName]} >
    {children}
  </BraidProvider>
);
